/**
 * Open-file session helpers — persist which deal is open across browser refresh.
 * Draft = no currentFileId. Opening a saved deal stores id+name in the autosave buffer.
 */

export const AUTOSAVE_KEY = 'redev-cockpit-autosave';

export function getOpenFileSession(autosave) {
  const id = autosave?.currentFileId;
  if (!id || typeof id !== 'string' || !id.trim()) {
    return { currentFileId: null, currentFileName: null, isDraft: true };
  }
  const name = autosave?.currentFileName;
  return {
    currentFileId: id,
    currentFileName: typeof name === 'string' && name.trim() ? name : null,
    isDraft: false,
  };
}

export function withOpenFileSession(payload, { currentFileId, currentFileName }) {
  return {
    ...payload,
    currentFileId: currentFileId || null,
    currentFileName: currentFileId ? (currentFileName || null) : null,
  };
}

/** Drop working buffer + open-file identity (logout / first-login draft). */
export function clearOpenFileAutosave() {
  try {
    localStorage.removeItem(AUTOSAVE_KEY);
  } catch { /* ignore quota / private mode */ }
}

/**
 * Map deal probe HTTP outcome → session action.
 * Only "missing" (404) should force draft; transient errors keep the open file.
 */
export function interpretDealAccessStatus(httpStatus, networkError = false) {
  if (networkError) return 'unavailable';
  if (httpStatus === 404) return 'missing';
  if (httpStatus >= 200 && httpStatus < 300) return 'ok';
  return 'unavailable';
}

/**
 * Session epoch fence — ignore stale boot async results after the user
 * opens another deal, starts New, or the analysis page unmounts.
 * Without this, a late 404 can clear currentFileId while leaving filled
 * project data on screen, so Save looks like a new draft and POST-creates
 * an unrelated duplicate. Unmount bumps the epoch from the boot effect
 * cleanup so that race does not require Open or New.
 */
export function bumpSessionEpoch(current) {
  const n = Number(current);
  return (Number.isFinite(n) ? n : 0) + 1;
}

export function isSessionEpochCurrent(startedAt, current) {
  return startedAt === current;
}
